import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  fragment WishlistItem on WishlistItem {\n    variant {\n      product {\n        ...BasicProductFields\n        category {\n          id\n          name\n          translation(languageCode: $languageCode) {\n            name\n          }\n        }\n      }\n      ...ProductVariantFields\n    }\n    productAttributes {\n      attribute {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n        values {\n          name\n          translation(languageCode: $languageCode) {\n            name\n          }\n        }\n      }\n      values\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { basicProductFragment, productVariantFragment } from "./products";
export var wishlistItemFragment = gql(_templateObject(), basicProductFragment, productVariantFragment);